// This import loads the firebase namespace along with all its type information.
import MetricInitialization from './metric-initialization-model'

export async function load_metricInitializations(): Promise<
  MetricInitialization[]
> {
  throw 'Not implemented'
}

export async function delete_metricInitialization(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_metricInitialization(): Promise<MetricInitialization> {
  throw 'Not implemented'
}
